import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ipInfo = defineConnector({
  identifier: "ipInfo",
  name: "IPInfo",
  tagLine: "IP geolocation and data",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: () => "https://ipinfo\\.io/.*",
  auth: (app) => queryAuth([{ name: "token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [IPInfo](https://ipinfo.io/) and create an account. Your API token is available on your account dashboard.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "IPInfo API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://ipinfo.io/8.8.8.8",
  },
});
